import axios from 'axios';

const tenantSystemApi = {
  async getMenuCount() {
    if (!axios.defaults.headers.common['X-tenant-id']) {
      return {};
    }
    const response = await axios.get('/api/tenant/system/menu-count');
    return response.data;
  },
};

export default tenantSystemApi;
